import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiHttpService } from '../../api-http.service';
import { ClientOrderTotals } from "../../../models/entities/ClientOrder/ClientOrderTotals";
import { CustomHttpResponse } from "../../../models/data/CustomHttpResponse";

@Injectable({
  providedIn: 'root',
})
export class ClientOrderTotalsService {
  apiService: ApiHttpService<ClientOrderTotals> = inject(ApiHttpService<ClientOrderTotals>);

  getClientOrderTotalsForOrder(iri: string): Observable<ClientOrderTotals> {
    return this.apiService.get(`${iri}/totals`).pipe(
      take(1),
      map((result: CustomHttpResponse<ClientOrderTotals>) => result.body),
    );
  }
}
